/*
 * PN 3.05 — Ürün görseli tam ekran galeri (21.10.2026)
 * Veri: sections/pn-galeri.liquid (#pn-gl-veri). Ayrıntı orada.
 */
(function () {
  'use strict';
  if (window.__pnGl) return;
  window.__pnGl = true;

  var veriEl = document.getElementById('pn-gl-veri');
  if (!veriEl) return;
  var V;
  try { V = JSON.parse(veriEl.textContent); } catch (e) { return; }
  if (!V.gorseller || !V.gorseller.length) return;

  var G = V.gorseller;
  var IKON_BUYUT = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="7" cy="7" r="4.6"/><path d="M10.4 10.4L14 14M7 5v4M5 7h4"/></svg>';
  var IKON_KAPAT = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/></svg>';

  function olay(ad) { try { if (typeof window.clarity === 'function') window.clarity('event', ad); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function siraBul(li) {
    var mid = (li.getAttribute('data-media-id') || '').split('-').pop();
    for (var i = 0; i < G.length; i++) if (String(G[i].id) === mid) return i;
    return -1;
  }

  /* Galerideki görsellere büyüteç simgesi */
  function ipucuEkle() {
    document.querySelectorAll('media-gallery .product__media-item').forEach(function (li) {
      if (li.__pnGl || siraBul(li) < 0) return;
      li.__pnGl = true;
      li.classList.add('pn-gl-var');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pn-gl-ipucu';
      b.setAttribute('aria-label', 'Görseli büyüt');
      b.innerHTML = IKON_BUYUT;
      li.appendChild(b);
    });
  }

  /* Galeri iskeleti (ilk açılışta bir kez) */
  var kok = null, ray, sayac, kucukler, fiyatEl, ekleBtn, kapatBtn;
  var aktif = 0, acik = false, gecmisVar = false, oncekiOdak = null;

  function kur() {
    if (kok) return;
    kok = document.createElement('div');
    kok.className = 'pn-gl';
    kok.hidden = true;
    kok.setAttribute('role', 'dialog');
    kok.setAttribute('aria-modal', 'true');
    kok.setAttribute('aria-label', V.baslik + ' görselleri');
    var s = '';
    G.forEach(function (g, i) {
      s += '<div class="pn-gl__slayt" data-i="' + i + '"><div class="pn-gl__kap"><img src="' + esc(g.b) + '" alt="' + esc(g.alt) + '" loading="' + (i < 2 ? 'eager' : 'lazy') + '" draggable="false"></div></div>';
    });
    var k = '';
    G.forEach(function (g, i) {
      k += '<button type="button" class="pn-gl__kucuk" data-i="' + i + '" aria-label="Görsel ' + (i + 1) + '"><img src="' + esc(g.k) + '" alt="" loading="lazy"></button>';
    });
    kok.innerHTML =
      '<div class="pn-gl__ust"><span class="pn-gl__sayac" aria-live="polite"></span>' +
      '<button type="button" class="pn-gl__kapat" aria-label="Kapat">' + IKON_KAPAT + '</button></div>' +
      '<div class="pn-gl__ray">' + s + '</div>' +
      (G.length > 1 ? '<div class="pn-gl__kucukler">' + k + '</div>' : '') +
      '<div class="pn-gl__alt"><p class="pn-gl__fiyat"></p><button type="button" class="pn-gl__ekle">Sepete Ekle</button></div>';
    document.body.appendChild(kok);
    ray = kok.querySelector('.pn-gl__ray');
    sayac = kok.querySelector('.pn-gl__sayac');
    kucukler = kok.querySelector('.pn-gl__kucukler');
    fiyatEl = kok.querySelector('.pn-gl__fiyat');
    ekleBtn = kok.querySelector('.pn-gl__ekle');
    kapatBtn = kok.querySelector('.pn-gl__kapat');

    kapatBtn.addEventListener('click', kapatIstek);
    ekleBtn.addEventListener('click', sepeteEkle);
    if (kucukler) kucukler.addEventListener('click', function (e) {
      var b = e.target.closest('.pn-gl__kucuk');
      if (b) git(parseInt(b.getAttribute('data-i'), 10), true);
    });
    var bekle = false;
    ray.addEventListener('scroll', function () {
      if (bekle) return;
      bekle = true;
      requestAnimationFrame(function () {
        bekle = false;
        var i = Math.round(ray.scrollLeft / Math.max(1, ray.clientWidth));
        if (i !== aktif) { sifirla(aktif); aktif = i; guncelle(); }
      });
    }, { passive: true });
    kok.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); kapatIstek(); }
      else if (e.key === 'ArrowRight') git(aktif + 1, true);
      else if (e.key === 'ArrowLeft') git(aktif - 1, true);
    });
    yakinlastirmaKur();
  }

  function guncelle() {
    sayac.textContent = (aktif + 1) + ' / ' + G.length;
    if (kucukler) {
      kucukler.querySelectorAll('.pn-gl__kucuk').forEach(function (b, i) {
        if (i === aktif) { b.setAttribute('aria-current', 'true'); try { b.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {} }
        else b.removeAttribute('aria-current');
      });
    }
  }

  function git(i, yumusak) {
    i = Math.max(0, Math.min(G.length - 1, i));
    var x = i * ray.clientWidth;
    try { ray.scrollTo({ left: x, behavior: yumusak ? 'smooth' : 'auto' }); } catch (e) { ray.scrollLeft = x; }
    if (!yumusak) { sifirla(aktif); aktif = i; guncelle(); }
  }

  function fiyatOku() {
    var bilgi = document.querySelector('[id^="ProductInfo-"]');
    var p = bilgi && bilgi.querySelector('[id^="price-"]');
    if (!p) return '';
    var adaylar = p.querySelectorAll('.price-item--sale, .price-item--regular');
    for (var i = 0; i < adaylar.length; i++) {
      var r = adaylar[i].getBoundingClientRect();
      if (r.width > 0 && adaylar[i].textContent.trim()) return adaylar[i].textContent.replace(/\s+/g, ' ').trim();
    }
    return p.textContent.replace(/Fiyat|Normal fiyat|Satış fiyatı/gi, '').replace(/\s+/g, ' ').trim();
  }

  function asilButon() {
    var bilgi = document.querySelector('[id^="ProductInfo-"]');
    return (bilgi && bilgi.querySelector('.product-form__submit')) || document.querySelector('product-form .product-form__submit');
  }

  function ac(i) {
    kur();
    oncekiOdak = document.activeElement;
    kok.hidden = false;
    document.documentElement.classList.add('pn-gl-acik');
    acik = true;
    var f = fiyatOku();
    fiyatEl.innerHTML = '<span>' + esc(V.baslik) + '</span>' + (f ? '<b>' + esc(f) + '</b>' : '');
    var a = asilButon();
    ekleBtn.disabled = !a || a.disabled;
    ekleBtn.textContent = a && a.disabled ? (a.textContent.trim() || 'Tükendi') : 'Sepete Ekle';
    aktif = i;
    git(i, false);
    guncelle();
    try { history.pushState({ pnGl: true }, ''); gecmisVar = true; } catch (e) { gecmisVar = false; }
    setTimeout(function () { try { kapatBtn.focus({ preventScroll: true }); } catch (e) {} }, 30);
    olay('galeri_acildi');
  }

  function kapat() {
    if (!acik) return;
    acik = false;
    sifirla(aktif);
    kok.hidden = true;
    document.documentElement.classList.remove('pn-gl-acik');
    if (oncekiOdak && oncekiOdak.focus) { try { oncekiOdak.focus({ preventScroll: true }); } catch (e) {} }
  }

  function kapatIstek() {
    if (gecmisVar && history.state && history.state.pnGl) { history.back(); }
    else kapat();
  }

  window.addEventListener('popstate', function () {
    if (acik) { gecmisVar = false; kapat(); }
  });

  function sepeteEkle() {
    var a = asilButon();
    if (!a || a.disabled) return;
    olay('galeri_sepete_ekle');
    kapatIstek();
    setTimeout(function () { a.click(); }, 80);
  }

  /* Yakınlaştırma: çift dokunuş + iki parmak */
  var Z = {};
  function kapEl(i) { var s = ray && ray.children[i]; return s && s.firstElementChild; }

  function boyut(kap, img, z, odakX, odakY) {
    var kw = kap.clientWidth, kh = kap.clientHeight;
    var o = (G[+kap.parentElement.getAttribute('data-i')] || {}).o || (img.naturalWidth / Math.max(1, img.naturalHeight)) || 1;
    var tw = kw / kh < o ? kw : kh * o; // sığdırılmış genişlik
    var w = tw * z, h = w / o;
    var once = { w: img.offsetWidth || tw, h: img.offsetHeight || tw / o, sl: kap.scrollLeft, st: kap.scrollTop };
    img.style.width = w + 'px';
    img.style.height = h + 'px';
    img.style.marginLeft = Math.max(0, (kw - w) / 2) + 'px';
    img.style.marginTop = Math.max(0, (kh - h) / 2) + 'px';
    if (odakX != null) {
      var px = (once.sl + odakX - Math.max(0, (kw - once.w) / 2)) / once.w;
      var py = (once.st + odakY - Math.max(0, (kh - once.h) / 2)) / once.h;
      kap.scrollLeft = px * w - odakX + Math.max(0, (kw - w) / 2);
      kap.scrollTop = py * h - odakY + Math.max(0, (kh - h) / 2);
    }
  }

  function yakinAyarla(i, z, odakX, odakY) {
    var kap = kapEl(i); if (!kap) return;
    var img = kap.querySelector('img');
    z = Math.max(1, Math.min(4, z));
    if (z <= 1.02) { sifirla(i); return; }
    if (!kap.classList.contains('is-yakin')) {
      kap.classList.add('is-yakin');
      kok.classList.add('is-yakin');
      boyut(kap, img, 1);
    }
    Z[i] = z;
    boyut(kap, img, z, odakX, odakY);
  }

  function sifirla(i) {
    var kap = kapEl(i); if (!kap) return;
    var img = kap.querySelector('img');
    kap.classList.remove('is-yakin');
    img.style.width = img.style.height = img.style.marginLeft = img.style.marginTop = '';
    kap.scrollLeft = kap.scrollTop = 0;
    Z[i] = 1;
    if (kok) kok.classList.remove('is-yakin');
  }

  function yakinlastirmaKur() {
    var sonDokunus = 0, sonX = 0, sonY = 0, tutam = null;
    function ayr(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }

    ray.addEventListener('touchstart', function (e) {
      var kap = e.target.closest('.pn-gl__kap'); if (!kap) return;
      var r = kap.getBoundingClientRect();
      if (e.touches.length === 2) {
        tutam = {
          d: ayr(e.touches), z: Z[aktif] || 1,
          x: (e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left,
          y: (e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top
        };
        e.preventDefault();
      }
    }, { passive: false });

    ray.addEventListener('touchmove', function (e) {
      if (!tutam || e.touches.length !== 2) return;
      e.preventDefault();
      yakinAyarla(aktif, tutam.z * ayr(e.touches) / tutam.d, tutam.x, tutam.y);
    }, { passive: false });

    ray.addEventListener('touchend', function (e) {
      if (tutam && e.touches.length < 2) { tutam = null; if ((Z[aktif] || 1) < 1.05) sifirla(aktif); return; }
      if (e.changedTouches.length !== 1 || e.touches.length) return;
      var t = e.changedTouches[0], simdi = Date.now();
      var kap = e.target.closest('.pn-gl__kap'); if (!kap) return;
      if (simdi - sonDokunus < 300 && Math.abs(t.clientX - sonX) < 30 && Math.abs(t.clientY - sonY) < 30) {
        e.preventDefault();
        var r = kap.getBoundingClientRect();
        if ((Z[aktif] || 1) > 1.05) sifirla(aktif); else yakinAyarla(aktif, 2.5, t.clientX - r.left, t.clientY - r.top);
        sonDokunus = 0;
      } else { sonDokunus = simdi; sonX = t.clientX; sonY = t.clientY; }
    }, { passive: false });

    // Masaüstü: çift tıklama
    ray.addEventListener('dblclick', function (e) {
      var kap = e.target.closest('.pn-gl__kap'); if (!kap) return;
      var r = kap.getBoundingClientRect();
      if ((Z[aktif] || 1) > 1.05) sifirla(aktif); else yakinAyarla(aktif, 2.5, e.clientX - r.left, e.clientY - r.top);
    });
  }

  /* Galeriye dokunuş */
  document.addEventListener('click', function (e) {
    var li = e.target.closest && e.target.closest('media-gallery .product__media-item');
    if (!li) return;
    if (e.target.closest('a, video, iframe, model-viewer, deferred-media, button:not(.pn-gl-ipucu)')) return;
    var i = siraBul(li);
    if (i < 0) return;
    e.preventDefault();
    ac(i);
  });

  ipucuEkle();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ipucuEkle);
  // Varyant değişince tema galeriyi yeniden çizebilir
  var mg = document.querySelector('media-gallery');
  if (mg && 'MutationObserver' in window) new MutationObserver(ipucuEkle).observe(mg, { childList: true, subtree: true });
})();
